"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.packageJSONReducer = exports.isInitReducer = exports.expectOfflineReducer = exports.deviceModeReducer = exports.appModeReducer = exports.appRootReducer = void 0;

var _immutable = require("immutable");

var _actions = require("./actions");

var _constants = require("../constants/constants");

/**
 * @classdesc
 * Actions creators functions, which helps to create and action.
 *
 * @namespace skybase-core.base.reducers
 *
 */

/**
 * The appRootReducer is responsible to set the root of the application.
 * The default root is '/ui/'
 *
 * @name skybase-core.base.reducers#appRootReducer
 *
 * @function
 *
 * @param  {String} [state=''] The text representation of the application root
 * @param  {ActionType.SetAppRoot} action={}
 */
var appRootReducer = function appRootReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type;

  var _ref = action.payload || {},
      appRoot = _ref.appRoot;

  return type === _actions.SET_APP_ROOT ? appRoot : state;
};

exports.appRootReducer = appRootReducer;

var appModeReducer = function appModeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type;

  var _ref2 = action.payload || {},
      mode = _ref2.mode;

  return type === _actions.SET_APP_MODE ? mode : state;
};
/**
 * The deviceModeReducer is responsible to set handle different modes, and mode changes
 *
 * @name skybase-core.base.reducers#deviceModeReducer
 *
 * @function
 *
 * @param  {String} [state=''] The text representation of the application root
 * @param  {ActionType.ChangeMode} action={}
 */


exports.appModeReducer = appModeReducer;

var deviceModeReducer = function deviceModeReducer() {
  var deviceMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.deviceModes.NORMAL_MODE;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type;

  var _ref3 = action.payload || {},
      modeId = _ref3.modeId;

  switch (type) {
    case _actions.CHANGE_MODE:
      return modeId;

    default:
      return deviceMode;
  }
};
/**
 * Tells whether an offline event is expected or not.
 * @param {boolean} expectOffline
 * @param {ActionType.SetExpectOffline} action
 * @returns {state}
 */


exports.deviceModeReducer = deviceModeReducer;

var expectOfflineReducer = function expectOfflineReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type;

  var _ref4 = action.payload || {},
      expected = _ref4.expected;

  return type === _actions.SET_EXPECT_OFFLINE ? expected : state;
};
/**
 * Marks specified page as initialized, when the action is triggered.
 *
 * @name skybase-core.base.reducers#isInitReducer
 * @function
 *
 * @param  {immutablejs.Map} state the current state
 * @param  {ActionType.PageIsInit} action
 */


exports.expectOfflineReducer = expectOfflineReducer;

var isInitReducer = function isInitReducer(state) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type;

  var _ref5 = action.payload || {},
      isInit = _ref5.isInit;

  if (type === _actions.PAGE_IS_INIT) {
    return state.set('isInit', isInit);
  }

  return state;
};
/**
 * @desc
 * Returns default state for packageJSONReducer
 *
 * @return {Object} *   - Default state
 */


exports.isInitReducer = isInitReducer;

var getDefaultStateForPackageJSONReducer = function getDefaultStateForPackageJSONReducer() {
  return (0, _immutable.fromJS)({});
};
/**
 * @desc
 * Reducer for SET_PACKAGEJSON_DATA action.
 *
 * @param  {Object} state       - Immutable store's state
 * @param  {Object} action      - Action object with type and payload
 * @return {immutablejs.Map}    - New or original state
 */


var packageJSONReducer = function packageJSONReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultStateForPackageJSONReducer();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type;

  var _ref6 = action.payload || {},
      data = _ref6.data;

  switch (type) {
    case _actions.SET_PACKAGEJSON_DATA:
      {
        return (0, _immutable.fromJS)(data);
      }

    default:
      return state;
  }
};

exports.packageJSONReducer = packageJSONReducer;
//# sourceMappingURL=reducers.js.map